import {AuthenticationError, type ServerAuthenticationEntryPoint} from './types.js';
import {type ServerWebExchangeMatcher} from '../util/matchers.js';
import {HttpStatus} from '../../http/status.js';
import getLogger from '../../logger.js';
import type {ServerWebExchange} from '../../../types/web/server';

const logger = getLogger('auth.entry-point');

export const delegatingEntryPoint = (opts: {
    entryPoints: Array<[ServerWebExchangeMatcher, ServerAuthenticationEntryPoint]>;
    defaultEntryPoint: ServerAuthenticationEntryPoint;
}): ServerAuthenticationEntryPoint => {
    const defaultEntryPoint = opts.defaultEntryPoint ?? (async ({response}, _error) => {
        response.setStatusCode(HttpStatus.UNAUTHORIZED);
        await response.end();
    });
    return async (exchange: ServerWebExchange, error: AuthenticationError) => {
        for (const [matcher, entryPoint] of opts.entryPoints) {
            if (logger.enabledFor('debug')) {
                logger.debug(`trying to match using: ${matcher}`);
            }
            const match = await matcher(exchange);
            if (match.match) {
                if (logger.enabledFor('debug')) {
                    logger.debug(`match found. using default entry point ${entryPoint}`);
                }
                return entryPoint(exchange, error);
            }
        }
        if (logger.enabledFor('debug')) {
            logger.debug(`no match found. using default entry point ${defaultEntryPoint}`);
        }
        return defaultEntryPoint(exchange, error);
    };
}
